import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

const tabs = [
    {
        title: 'academy.tabs.tab_01.title',
        rows: [
            'academy.tabs.tab_01.text_01',
            'academy.tabs.tab_01.text_02',
            'academy.tabs.tab_01.text_03',
            'academy.tabs.tab_01.text_04',
            'academy.tabs.tab_01.text_05',
            'academy.tabs.tab_01.text_06',
            'academy.tabs.tab_01.text_07',
        ],
    },
    {
        title: 'academy.tabs.tab_02.title',
        rows: [
            'academy.tabs.tab_02.text_01',
            'academy.tabs.tab_02.text_02',
            'academy.tabs.tab_02.text_03',
            [
                'academy.tabs.tab_02.li_01',
                'academy.tabs.tab_02.li_02',
                'academy.tabs.tab_02.li_03',
                'academy.tabs.tab_02.li_04',
                'academy.tabs.tab_02.li_05',
            ],
            'academy.tabs.tab_02.text_04',
            'academy.tabs.tab_02.text_05',
            'academy.tabs.tab_02.text_06',
            'academy.tabs.tab_02.text_07',
        ],
    },
    {
        title: 'academy.tabs.tab_03.title',
        rows: [
            'academy.tabs.tab_03.text_01',
            'academy.tabs.tab_03.text_02',
            'academy.tabs.tab_03.text_03',
            'academy.tabs.tab_03.text_04',
            'academy.tabs.tab_03.text_05',
            'academy.tabs.tab_03.text_06',
            'academy.tabs.tab_03.text_07',
            'academy.tabs.tab_03.text_08',
            'academy.tabs.tab_03.text_09',
        ],
    },
];

const Tabs = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);

    const setTab = value => active === value
        ? setActive(-1)
        : setActive(value);

    return (
        <section className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative flex flex-col xl:gap-[65px] lg:gap-[50px]">
                {tabs.map((tab, index) =>
                    <div
                        key={index}
                        onClick={() => setTab(index)}
                        className="flex flex-col lg:flex-row lg:gap-[15px] border-b-[2px] border-b-[#0C278080] lg:border-none py-[10px] lg:py-0"
                    >
                        <div className="flex gap-[15px] items-center lg:items-start justify-between lg:justify-start">
                            <div className="mt-[8px] w-[11px] h-[11px] hidden lg:flex rounded-[30px] bg-[#0C2780]"></div>
                            <h4 className="xl:w-[339px] lg:w-[280px] font-[600] open-sans sm:text-[19px] text-[14px] text-[#0C2780]">
                                {t(tab.title)}
                            </h4>
                            <div className="lg:hidden w-[16px] h-[16px] relative flex-shrink-0">
                                <span className="absolute w-[100%] h-[2px] bg-[#0C2780] left-0 top-[50%] -translate-y-[50%]"></span>
                                <span className={`absolute w-[100%] h-[2px] bg-[#0C2780] left-0 top-[50%] -translate-y-[50%] ${index === active ? 'rotate-0' : 'rotate-90'} duration-200`}></span>
                            </div>
                        </div>
                        <div className={`${index === active ? 'flex' : 'hidden'} w-auto lg:flex flex-col sm:gap-[15px] gap-[10px] font-[300] open-sans sm:text-[16px] text-[14px] text-[#0C2780] lg:mt-0 mt-[15px]`}>
                            {tab.rows.map((row, rowIndex) =>
                                typeof (row) === 'string' ?
                                    <p className="" key={rowIndex}>
                                        <Trans>
                                            {t(row)}
                                        </Trans>
                                    </p>
                                    :
                                    <ul className="flex flex-col sm:gap-[15px] gap-[10px] list-outside list-disc sm:pl-[25px] pl-[20px]" key={rowIndex}>
                                        {row.map((li, liIndex) =>
                                            <li className="" key={liIndex}>
                                                <Trans>
                                                    {t(li)}
                                                </Trans>
                                            </li>
                                        )}
                                    </ul>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </section>
    )
};

export default Tabs;
